import { forwardRef } from 'react';
import { Select, ErrorMessage } from './Select.style';
import { ErrorSolidIcon } from '@icons';
import { SelectHTMLAttributes } from 'react';
import { FormLabel } from '..';

interface FormSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  errorText?: string;
  label?: string;
  tooltip?: {
    title: string;
    content: string;
  };
}

const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(
  ({ errorText, label, tooltip, ...props }, ref) => {
    return (
      <div>
        {label && (
          <FormLabel htmlFor={props.id} tooltip={tooltip}>
            {label}
          </FormLabel>
        )}
        <Select {...props} ref={ref} hasError={!!errorText} />
        {errorText && (
          <ErrorMessage>
            <ErrorSolidIcon /> <span>{errorText}</span>
          </ErrorMessage>
        )}
      </div>
    );
  }
);

FormSelect.displayName = 'FormSelect';

export default FormSelect;
